$(function () {

	const $body = $('body');
	const headerWhite = [2, 3, 4, 6, 7, 8];

	const onScrollify = function () {
		$.scrollify({
			section: ".js_section",
			overflowScroll: true,
			before: function (i, panels) {
				const num = i + 1;
				if (headerWhite.includes(num)) {
					$body.addClass('--wh');
				} else {
					$body.removeClass('--wh');
				}

				$(".pagination .active").removeClass("active");
				$(".pagination").find("a[href=\"#" + num + "\"]").addClass("active");
			},
			afterRender: function () {
				var pagination = "<ul class=\"pagination\">";
				var activeClass = "";
				$(".js_section").each(function (i) {
					const num = i + 1;
					activeClass = "";
					if (i === $.scrollify.currentIndex()) {
						activeClass = "active";
					}
					pagination += "<li><a class=\"" + activeClass + "\" href=\"#" + num + "\"><span class=\"hover-text\"></span></a></li>";
				});

				pagination += "</ul>";

				$(".home").append(pagination);
				$(".pagination a").on("click", $.scrollify.move);
			},
		});

		$(".scrollify-move").each(function () {
			$(this).on('click', function () {
				let href = $(this).attr("href");
				$.scrollify.move(href);
			});
		});
	};

	$(window).on('load scroll', function () {
		if (window.innerWidth <= 480) {
			if (typeof $.scrollify.current() !== 'undefined') {
				$.scrollify.destroy();
			}
		} else {
			if (typeof $.scrollify.current() === 'undefined') {
				onScrollify();
			}
		}
	});
});
